module.exports = __webpack_public_path__ + "static/service_en_bg@2x-a43c755d8224f74bc7c9de37a563740e.png";